import $ from 'jquery';

// FAQ
$(document).ready(function() {
    $('.faq-title').click(function() {
        var $faqText = $(this).next('.faq-text');
        var $faqTitle = $(this); // Référence au .faq-title cliqué

        // Retirer la classe 'active' de tous les .faq-title sauf celui cliqué
        $('.faq-title').not($faqTitle).removeClass('active');
        $('.faq-text').not($faqText).slideUp();

        if ($faqText.is(':visible')) {
            $faqTitle.removeClass('active');
            $faqText.slideUp();
        } else {
            $faqTitle.addClass('active');
            $faqText.slideDown();
        }
    });
});


// General accordion
$(document).ready(function() {
    $('.accordion-title').click(function() {
        var $accordionText = $(this).next('.accordion-text');
        var $accordionTitle = $(this); // Référence au .accordion-title cliqué

        // Retirer la classe 'active' de tous les .accordion-title sauf celui cliqué
        $('.accordion-title').not($accordionTitle).removeClass('active');
        $('.accordion-text').not($accordionText).slideUp();

        if ($accordionText.is(':visible')) {
            $accordionTitle.removeClass('active');
            $accordionText.slideUp();
        } else {
            $accordionTitle.addClass('active');
            $accordionText.slideDown();
        }
    });
});

// Expertise
$(document).ready(function() {
    $('.expertise-title').click(function() {
        var $expertiseText = $(this).next('.expertise-text');
        var $expertiseTitle = $(this); // Référence au .expertise-title cliqué

        // Retirer la classe 'active' de tous les .expertise-title sauf celui cliqué
        $('.expertise-title').not($expertiseTitle).removeClass('active');
        $('.expertise-text').not($expertiseText).slideUp();

        if ($expertiseText.is(':visible')) {
            $expertiseTitle.removeClass('active');
            $expertiseText.slideUp();
        } else {
            $expertiseTitle.addClass('active');
            $expertiseText.slideDown();
        }
    });
});
